export default "__VITE_ASSET__vNJPa3yZ__"